import styles from "./TableColumn.module.scss";

const TableColumn = ({ children }) => {
  return <div className={styles.tableColumn}>{children}</div>;
};
export default TableColumn;
